import React from "react";
import {LineChart,AreaChart,Area, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line, ResponsiveContainer} from "recharts";
import {useListVals} from "react-firebase-hooks/database";
import Firebase from "../../Firebase";
import distinctColors from "distinct-colors";
import {useCollection} from "react-firebase-hooks/firestore";


const data = [{
    name: 'Page A',
    uv: 10,
    pv: 2400,
    amt: 2400,
}, {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,}, {
    name: 'Page C',
    uv: 2000,
    pv: 9800,
    amt: 2290 },
    {
        name: 'Page D',
        uv: 2780,
        pv: 3908,
        amt: 2000,
    },
    {
        name: 'Page E',
        uv: 1890,
        pv: 4800,
        amt: 2181,
    },
    {
        name: 'Page F',
        uv: 2390,
        pv: 3800,
        amt: 2500,
    },
    {
        name: 'Page G',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },{
        name: 'Page A',
        uv: 4000,
        pv: 2400,
        amt: 2400,
    }, {
        name: 'Page B',
        uv: 3000,
        pv: 1398,
        amt: 2210,}, {
        name: 'Page C',
        uv: 2000,
        pv: 9800,
        amt: 2290 },
    {
        name: 'Page D',
        uv: 2780,
        pv: 3908,
        amt: 2000,
    },
    {
        name: 'Page E',
        uv: 1890,
        pv: 4800,
        amt: 2181,
    },
    {
        name: 'Page F',
        uv: 2390,
        pv: 3800,
        amt: 2500,
    },
    {
        name: 'Page G',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    } ];

const db = Firebase.firestore();
function MostSalesUser(props){

    var moment = require('moment');

    const [users] = useCollection(
        db.collection('users'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [sales] = useCollection(
        db.collection('sales'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [weekdays, setWeekDays] = React.useState([]);
    const [labelArray, setLabelArray] = React.useState([]);
    const [dataArray, setDataArray] = React.useState([]);
    const [majorArray, setMajorArray] = React.useState([1,2,3]);
    const [loading , setLoading] = React.useState(false);
    const [paletteArray, setPaletteArray] = React.useState([]);


    var todayNum = moment().isoWeekday();
    //var lastWeekToday = todayNum - 14;
    //console.log(moment().weekday(lastWeekToday));

    React.useEffect(() => {

        //setLoading(true);
        var periodNumber;
        if(props.period === "Last 7 days" ){
            periodNumber = 7;
        }else if(props.period === "Last 30 days"){
            periodNumber = 30;
        } else {
            periodNumber = 90;
        }

        var weekArray = [];
        var labelArray = [];

        for(var i=0; i<periodNumber; i++){
            weekArray.push({"date" : moment().weekday(todayNum - i).format("YYYY-MM-DD"),
                "name" : moment().weekday(todayNum - i).format("dddd")});
            labelArray.push(moment().weekday(todayNum - i).format("DD/MM"));
        }

        setLabelArray(labelArray);
        setWeekDays(weekArray);

        var tempuserArray = [];
        if(users){
            users.docs.map((item) => {
                var user = item.data();
                if(user.role === "SalesRep"){
                    user["key"] = user.firstname;

                    var x = 95+Math.floor(Math.random() * 200);
                    var y = 12+ Math.floor(Math.random() * 200);
                    var z = -7+Math.floor(Math.random() * 200);
                    user["color"] = "rgb(" + x + "," + y + "," + z + ")";

                    tempuserArray.push(user);
                }
            });
            setMajorArray(tempuserArray);
        }

        var tempArray = [];
        if(sales){
            var salesArray = []
            sales.docs.map((item) => {
                salesArray.push(item.data());
            })
            weekArray.map((weekday) => {
                var filtered = salesArray.filter(x => (moment(x.updatedAt, "YYYY-MM-DD h:mm:SSS").format("YYYY-MM-DD") === weekday.date));

                //count = filtered.length;

                var dataItem = {
                    name : moment(weekday.date, "YYYY-MM-DD").format("DD/MM")
                };

                filtered.map((item) => {
                    //console.log(item);
                    var name = users[users.findIndex(x => (x.userID) === item.salesRepID)]&&
                        users[users.findIndex(x => (x.userID) === item.salesRepID)].firstname; //+ " " +
                        //users[users.findIndex(x => (x.userID) === item.salesRepID)].surname
                    if(dataItem[name] == null || dataItem[name] === undefined){
                        dataItem[name] = 1;
                    } else {
                        dataItem[name] = dataItem[name] + 1;
                    }
                });

                tempuserArray.map((userItem) => {
                   if(dataItem[userItem.firstname]== null || dataItem[userItem.firstname] === undefined) {
                       dataItem[userItem.firstname] = 0;
                   }
                });
                tempArray.push(dataItem);
            });
        }

        var palette = distinctColors({count: tempArray.length});
        setPaletteArray(palette);
        setDataArray([...tempArray.reverse()]);

    }, [moment, props.period, sales, todayNum, users])


    return (

        <ResponsiveContainer width="100%" height={250} className="d-flex justify-content-center text-center">
            <LineChart
                data={dataArray}
                margin={{
                    top: 5,
                    right: 10,
                    left: 0,
                    bottom: 5,
                }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis allowDecimals={false}/>
                <Tooltip />
                <Legend />
                {majorArray.map((item,index) => (
                    <Line type="monotone" strokeWidth={1} dataKey={item.key} stroke={paletteArray[index]} fillOpacity={0.6} fill="url(#colorUv)" />
                ))}
            </LineChart>
        </ResponsiveContainer>


    )
}

export default MostSalesUser;
